import React from "react";
import { useNavigate } from "react-router-dom";
import "./CustomButton.css";

function CustomButton({ buttonIcon, style, name }) {
  const navigate = useNavigate();
  return (
    <button className="cb_main_container" onClick={() => navigate("/payment")}>
      <div className="cb_icon">
        {buttonIcon && React.cloneElement(buttonIcon, { style }, null)}
      </div>
      {name ? name : "Donate Now"}
    </button>
  );
}

export default CustomButton;
